import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { TransformerSpecific } from './TypedNode'

export interface SchemaTransformerSpecific extends RehajeSchemaMetadata {
  /**
   * Transformer 默认配置
   */
  default?: TransformerSpecific
  type: 'Schema.Transformer'
  /**
   * 值
   */
  value?: any
}

export class SchemaTransformerDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaTransformerSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaTransformerSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaTransformerSpecific
  ): SchemaTransformerSpecific {
    return { ...this.inferOnlySchema(schema), value: target }
  }

  override inferOnlySchema(schema: SchemaTransformerSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaTransformerSpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaTransformerSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaTransformerSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Transformer': SchemaTransformerSpecific
  }
}
